import { render } from "./Menor.vue?vue&type=template&id=303e5203&ts=true"
import script from "./Menor.vue?vue&type=script&lang=ts"
export * from "./Menor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__